
  export default {
    name: `ButtonWithLoad`,
    data() {
      return {
        ready: false,
        loading: false
      }
    },
    methods: {
      start(seconds) {
        this.loading = true
        setTimeout(() => {
          this.ready = true
          this.loading = false
        }, seconds * 100)
      },
      clicked() {
        if (this.loading) return
        this.$emit(`click`)
      }
    }
  }
